import React from "react";
import ComingSoon from "./ComingSoon";

const EndUser = () => <ComingSoon title="End User" />;

export default EndUser;
